import * as React from 'react';
export const patelcoSvg = React.forwardRef(function patelcoSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#DE1436',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: '#FFF',
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M19.08 17.579c-.53.22-2.09.28-3.12-.08-1.82-.65-2.4-2.57-1-5.02 1.88-3.31 7.18-4.77 11.98-2.5 0 0-2.86-3.02-7.77-3.06-4.04-.03-9.1 2.86-9.61 6.56-.5 3.53 3.08 5.88 7.03 5.19 1.8-.32 2.49-1.09 2.49-1.09z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M9.79 10.549c-3.38 1.53-4.9 4-4.55 6.68.45 3.38 5.1 6.33 9.99 4.92 4-1.15 5.4-3.78 5.64-5.85 0 0-2.2 4.82-8.48 3.28a5.34 5.34 0 0 1-2.6-9.03z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M16.82 13.779c.66-.4 1.93-.55 3.15-.05 1.85.76 2.75 2.5 1.55 5.12-1.63 3.53-7.54 6.06-12 3.85 0 0 .3.34 1.15.79 2.22 1.17 7.33 3.1 12.53.18 4.06-2.27 4.4-6.27 2.66-8.71-1.69-2.36-4.86-2.83-6.6-2.5a4.1 4.1 0 0 0-2.44 1.32z',
        }),
      ),
    ),
  );
});
patelcoSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var patelco = {
  category: 'brand',
  colorable: false,
  name: 'patelco',
  svg: patelcoSvg,
};
